export default "__VITE_ASSET__BW3STZ_P__"